module.exports = __webpack_public_path__ + "img/bdd5180.png";